import React from 'react';
import { Alert } from 'react-bootstrap';

import { GetExtendedSalesInvoiceDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { SalesInvoiceStatusEnum } from '../../../common/pokCore/validation/enums';

interface AlertNoProjectsInSalesInvoiceItemsProps {
  extendedSalesInvoice?: GetExtendedSalesInvoiceDto;
}

export const AlertNoProjectsInSalesInvoiceItems: React.FC<
  AlertNoProjectsInSalesInvoiceItemsProps
> = ({ extendedSalesInvoice }) => {
  const { t, tk } = useTranslation('fvsLng');

  const projectIdsFromInvoice =
    extendedSalesInvoice?.salesInvoiceProjects
      ?.filter(sip => sip.active)
      ?.map(sip => sip.project?.id)
      ?.filter((id): id is string => !!id) ?? [];

  const invoiceEstimateItems = extendedSalesInvoice?.invoiceEstimateItems;
  if (invoiceEstimateItems === undefined) {
    return null;
  }

  const projectIdsFromEstimateItems = [
    ...new Set(
      invoiceEstimateItems
        .map(item => item.estimateItem?.estimateByMonth?.project?.id)
        .filter((id): id is string => !!id),
    ),
  ];

  const isZeroInvoice = Number(extendedSalesInvoice?.amountGross) === 0;

  const hasUnlinkedProjects =
    extendedSalesInvoice?.status === SalesInvoiceStatusEnum.Draft &&
    projectIdsFromInvoice.length > 0 &&
    projectIdsFromInvoice.some(
      projectId => !projectIdsFromEstimateItems.includes(projectId),
    );

  if (!hasUnlinkedProjects) {
    return null;
  }

  if (isZeroInvoice) {
    return (
      <Alert variant="info">{t(tk.prLang.zeroInvoiceProjectsWillBeKept)}</Alert>
    );
  }

  return (
    <Alert variant="warning">{t(tk.prLang.noProjectInEstimateItems)}</Alert>
  );
};
